import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/coco-app-platformhk/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/coco-app-platformhk/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/var/www/coco-app-platformhk/node_modules/next/dist/client/image-component.js");
